import keycloak from '../keycloak';

const BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api';

async function request(path, options = {}) {
  await keycloak.updateToken(30);
  const res = await fetch(`${BASE}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`,
    },
    ...options,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || res.statusText);
  }
  if (res.status === 204) return null;
  return res.json();
}

export const api = {
  contacts: {
    list: (type) => request(`/contacts${type ? `?type=${type}` : ''}`),
    get: (id) => request(`/contacts/${id}`),
    create: (data) => request('/contacts', { method: 'POST', body: JSON.stringify(data) }),
    update: (id, data) => request(`/contacts/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id) => request(`/contacts/${id}`, { method: 'DELETE' }),
  },
  invoices: {
    list: (type) => request(`/invoices${type ? `?type=${type}` : ''}`),
    get: (id) => request(`/invoices/${id}`),
    create: (data) => request('/invoices', { method: 'POST', body: JSON.stringify(data) }),
    update: (id, data) => request(`/invoices/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    copy: (id) => request(`/invoices/${id}/copy`, { method: 'POST' }),
    delete: (id) => request(`/invoices/${id}`, { method: 'DELETE' }),
  },
  reports: {
    get: (params) => request(`/reports?${new URLSearchParams(params)}`),
    years: () => request('/reports/years'),
  },
};
